import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";

var TaskTile = require("components/utility/TaskTile");
var Spinner = require("components/utility/Spinner");
var SlidingDrawer = require("components/utility/SlidingDrawer");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ProgressBar = require('components/users/students/ProgressBar')
var Features = require("lib/account/Features");

var CurrentUser = require("lib/account/CurrentUser");

var AccountPlans = require("lib/account/AccountPlans");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
const WritingActions = require('lib/actions/WritingActions');
var WritingSelectors = require("lib/selectors/WritingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var BookDisplay = require("components/reading/books/BookDisplay")
var BookCover = require("components/reading/books/BookCover");
var StudentMetrics = require("lib/data/StudentMetrics");

var MyShelfRouting = require("lib/routing/MyShelfRouting");

@connect(
  (state, props) => ({
    revisables: ReadingSelectors.booksWithRevisables({ state, conditions: { userID: CurrentUser.get().id } }),
    books: ReadingSelectors.books({ state, conditions: { allowDraft: true, nonBlank: ["text_id", "title"] } }),
    allExercises: WritingSelectors.activities({ state }) || [],
    allTasks: WritingSelectors.validStudentHomepageTasks({ state, conditions: { userID: CurrentUser.get().id } }),
    product: CurrentUser.get().product,
    showQuestionBuilders: CurrentUser.get().prefs.display_question_builder || false
  }),

  (dispatch, props) => ({
    populateData: () => {
      dispatch(ReadingActions.fetchLibraryPlatforms({ cache: true }));
      // loads exercises into state
      dispatch((dispatch, getState) => {
        var allAssignedExercisesIDs = _.compact(_.map((getState().tasks), (activity) => {
          var exerciseTaskItems = _.where(activity.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE })
          exerciseTaskItems = exerciseTaskItems.concat(_.where(activity.task_items, { subject_type: ACTIVITY_SUBJECT_TYPE }))
          if (activity.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE || activity.subject_type === ACTIVITY_SUBJECT_TYPE) {
            return parseInt(activity.subject_id);
          } else if (!_.isEmpty(exerciseTaskItems)) {
            return parseInt(exerciseTaskItems.subject_id);
          }
        }))

        if (!_.isEmpty(allAssignedExercisesIDs)) {
          _.each(allAssignedExercisesIDs, (exerciseID) => { dispatch(WritingActions.fetchActivity({ id: exerciseID, embeds: ["activity.format"] })) })
        }
      })
      // loads books into state
      return dispatch((dispatch, getState) => {
        // This only works because the tasks are already loaded in before this component mounts
        // It's not very stable. Or elegant.
        var readingTasks = WritingSelectors.teacherPicksTasks({
          state: getState(), filters: { user_id: CurrentUser.get().id }
        });

        if (readingTasks.length > 0) {
          return dispatch(ReadingActions.fetchBooks({
            ids: _.pluck(readingTasks, "subject_id"),
            user_id: CurrentUser.get().id,
            cache: true,
            query: { library_content: true }
          }))
        } else {
          return Promise.resolve();
        }
      })
    }
  })
)
@providePopulateData({ waitForLoad: true })
class StudentActivities extends React.Component {
  constructor(props) {
    super();
    autobind(this);
  
    var allActivities = props.allTasks
    allActivities.sort(function compare(a, b) {
      var dateA = a.due_date === null ? new Date(new Date().setFullYear(new Date().getFullYear() + 100)) : new Date(a.due_date);
      var dateB = b.due_date === null ? new Date(new Date().setFullYear(new Date().getFullYear() + 100)) : new Date(b.due_date);
      return dateA - dateB;
    });
    // set drawer status for each item
    var drawerOpen = {}
    if (!_.isEmpty(allActivities)) {
      _.each(allActivities, (item) => {
        var drawerOpenCopy = { ...drawerOpen }
        drawerOpenCopy[`${item.id}`] = false;
        drawerOpen = drawerOpenCopy
      })
    }
    this.state = { allActivities: allActivities, drawerOpen: drawerOpen }
  }

  /*//////////////////
  Redirect users
  ///////////////////*/
  openQuiz(e) {
    $wr.nope(e)
    // Don't check text variety for quizzes
    this.setState({ loading: true });
    $wr.redirect("/quiz?text_id=" + e.target.getAttribute('data-text-id'));
  }

  openLogReading(e) {
    $wr.nope(e)
    LuckyOrangeClient.tagComponent("ReadingLogModal");
    this.props.openBookActivity('log', _.findWhere(this.props.books, { text_id: e.target.getAttribute('data-text-id')}))
  }

  openReview(e) {
    $wr.nope(e)
    this.setState({ loading: true });
    $wr.redirect("/reviews/new?text_id=" + e.target.getAttribute('data-text-id'));
  }

  openExercise(e) {
    $wr.nope(e)
    this.setState({ loading: true });
    var redirectURL = "/responses/new?text_id=" + e.target.getAttribute('data-text-id') + "&activity_ids=" + e.target.getAttribute('data-activity-ids');
    if (e.target.getAttribute('data-activity-id') !== 'none') {
      redirectURL = "/responses/new?text_id=" + e.target.getAttribute('data-text-id') + "&activity_id=" + e.target.getAttribute('data-activity-id');
    }
    $wr.redirect(redirectURL);
  }

  openQuestions(e) {
    $wr.nope(e)
    this.setState({ loading: true });
    $wr.redirect("/answers/new?text_id=" + e.target.getAttribute('data-text-id'));
  }
  // opens question builder for text
  openQuestionBuilder(e) {
    $wr.nope(e)
    this.setState({ loading: true });
    $wr.redirect("/question_builder/new?text_id=" + e.target.getAttribute('data-text-id'));
  }

  onRevisionClick(e) {
    if (e.currentTarget.getAttribute('data-item-type')) {
      if (e.currentTarget.getAttribute('data-item-type') == "quiz") {
        var detailsView = "quizzes"

      } else if (e.currentTarget.getAttribute('data-item-type') == "answer") {
        var detailsView = "answers"

      } else if (e.currentTarget.getAttribute('data-item-type') == "review") {
        var detailsView = "reviews"
      }

      $wr.redirect(MyShelfRouting.getPath({
        activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
        textID: e.currentTarget.getAttribute('data-text-id'),
        detailsView
      }));
    }
  }

  noEvent(e) {
    $wr.nope(e)
  }

  /*///////////////////////////////
  Dynamic based on completed status
  ////////////////////////////////*/
  
  calculatePercentFinished(task_items) {
    if (task_items) {
      // find finished tasks 
      var finishedQuiz = _.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ, draft: false });
      var finishedPracticeQuestions = _.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION, draft: false });
      var finishedReview = _.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW, draft: false });
      var finishedExercise = _.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, draft: false });
      var finishedQuestionBuilders = _.where(task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUESTION_BUILDER, draft: false });
      // sum completed tasks
      var completed_tasks = finishedQuiz.length + finishedPracticeQuestions.length + finishedReview.length + finishedExercise.length + finishedQuestionBuilders.length
      // return comparison
      return completed_tasks / task_items.length
    } else {
      return 0
    }
  }

  /*///////////////////////////////
  Helpers
  ////////////////////////////////*/
  hasQualifiedPlan() {
    var activeTrials = CurrentUser.get().account.active_trials
    var hasQualifiedTrial = activeTrials && (activeTrials[AccountPlans.PRODUCTS.WR_GOLD] || activeTrials[AccountPlans.PRODUCTS.WR_SILVER]) ? true : false
    return this.props.product === 'wrGold' || this.props.product === 'wrSilver' || hasQualifiedTrial ? true : false
  }

  isStandAloneBookActivity(item) {
    if (!item.task_items || !item.task_items.length) {
      return false
    }

    var exerciseTaskItems = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE})
    return _.size(exerciseTaskItems) !== _.size(item.task_items) ? false : true
  }

  textID(item) {
    if (item.text_id) {
      return item.text_id
    }
    // accounts for activities saved without textID (assigned before updates)
    else if (item.subject_id && (item.subject_type === URL_PICK_SUBJECT_TYPE || item.subject_type === TITLE_PICK_SUBJECT_TYPE)) {
      return item.subject_id
    } 
  }

  allBookActivity(item) {
    var book = _.first(_.where(this.props.books, { text_id: item.text_id }))
    if (book && book["activity:any:any"]) {
      var bookActivity = book["activity:any:any"];
      return bookActivity
    }
  }
  // incase a teacher enters an absurd number of assignments
  truncateMainText(text, charLength) {
    if (text.length > charLength) {
      return text.substring(0, (charLength - 1)) + "...";
    } else {
      return text
    }
  }
  // returns placeholder image for activities
  getPlaceholderImage() {
    if ($wr.isDevelopment()) {
      var imgBase = "http://localhost:3003";
    } else if ($wr.isProduction()) {
      var imgBase = "https://app.whooosreading.org/albus_assets";
    } else if ($wr.isStaging()){
      var imgBase = "https://app.savvashortondev.com/albus_assets";
    }

    return imgBase + "/imgs/placeholder-thumbnail.png";
  }

  /*///////////////////////////////
  Render elements
  ////////////////////////////////*/
  renderQuizActivity(item) {
    var glyphiconClass = 'hide-glyphicon'
    var altText = 'Take a Quiz'
    var mainText = 'Quiz'
    var clickEvent = this.openQuiz
    var dataTip = 'Complete the item before you start the quiz!'
    var completedClass = 'notRequired'
    var bookActivity = this.allBookActivity(item)
    var activityTextClass = 'activityItemText'

    var assignedQuiz = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ });
    if (assignedQuiz.length) {
      var finishedQuiz = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ, draft: false });
      if (finishedQuiz.length) {
        glyphiconClass = 'glyphicon glyphicon-check-green'
        altText = 'Completed Quiz'
        mainText = '1/1 Quiz'
        clickEvent = this.noEvent
        dataTip = 'You have completed the quiz!'
        completedClass = 'isCompleted'
        activityTextClass += ' deactivateLink'
      } else {
        glyphiconClass = 'glyphicon glyphicon-check-gray'
        mainText = '0/1 Quiz'
        completedClass = 'isRequired'
        activityTextClass = 'activityItemText'
      }
    } else if (bookActivity) {
      if (bookActivity.quiz_counts && bookActivity.quiz_counts[`${item.user_id}`] > 0) {
        mainText = '1/1 Quiz'
        activityTextClass += ' deactivateLink'
        clickEvent = this.noEvent
      }
    }
    mainText = this.truncateMainText(mainText, 25)
    completedClass += ' activityContainer'
    return (
      <a className={completedClass} href="#" data-text-id={this.textID(item)} key={item.id + '_' + item.receivedAt + '_quizIcon'} onClick={clickEvent}
        data-tip={dataTip}>
        <Glyphicon icon='glyphicon glyphicon-check' className={glyphiconClass}/>
        <img className='activityIcon' src={require("reading/student-icons-quiz.png")} alt={altText} />
        <span data-text-id={this.textID(item)} className={activityTextClass}>{mainText}</span>
      </a>
    )
  }

  renderQuestionActivity(item) {
    var glyphiconClass = 'hide-glyphicon'
    var altText = 'Answer a Question'
    var mainText = 'Questions'
    var clickEvent = this.openQuestions
    var dataTip = 'Try out some practice questions!'
    var completedClass = 'notRequired'
    var bookActivity = this.allBookActivity(item)
    var activityTextClass = 'activityItemText'

    var assignedPracticeQuestions = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION });
    
    if (assignedPracticeQuestions.length) {
      var finishedPracticeQuestions = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION, draft: false });

      if (finishedPracticeQuestions.length === assignedPracticeQuestions.length) {
        glyphiconClass = 'glyphicon glyphicon-check-green'
        altText = 'Answered all Questions'
        mainText = finishedPracticeQuestions.length + '/' + assignedPracticeQuestions.length + ' Questions'
        clickEvent = this.noEvent
        dataTip = 'You have completed the practice questions!'
        completedClass = 'isCompleted'
        activityTextClass += ' deactivateLink'
      } else {
        completedClass = 'isRequired'
        activityTextClass = 'activityItemText'
        glyphiconClass = 'glyphicon glyphicon-check-gray'
        mainText = finishedPracticeQuestions.length + '/' + assignedPracticeQuestions.length + ' Questions'
      }
    } else if (bookActivity && bookActivity.answer_counts) {
      var questionsCompleted = bookActivity.answer_counts[`${item.user_id}`]
      if (questionsCompleted > 0) {
        if (questionsCompleted === 1) {
          mainText = `1 Question`
        } else {
          mainText = `${questionsCompleted} Questions`
        }
      }
    }
    mainText = this.truncateMainText(mainText, 25)
    completedClass += ' activityContainer'
    return (
      <a className={completedClass} href="#" data-text-id={this.textID(item)} key={item.title + '_' + item.receivedAt + '_questionsIcon'} onClick={clickEvent}
        data-tip={dataTip}>
        <Glyphicon icon='glyphicon glyphicon-check' className={glyphiconClass} />
        <img className='activityIcon' src={require("reading/student-icons-question.png")} alt={altText} />
        <span data-text-id={this.textID(item)} className={activityTextClass}>{mainText}</span>
      </a>
    )
  }

  renderExerciseActivity(item) {
    var glyphiconClass = 'hide-glyphicon'
    var altText = 'Complete an Exercise'
    var mainText = 'Exercises'
    var clickEvent = this.openExercise
    var dataTip = 'Complete an exercise!'
    var completedClass = 'notRequired'
    var bookActivity = this.allBookActivity(item)
    var activityTextClass = 'activityItemText'

    var assignedExercises = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE });

    if (assignedExercises.length) {
      var finishedExercises = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, draft: false });

      if (finishedExercises.length === assignedExercises.length) {
        glyphiconClass = 'glyphicon glyphicon-check-green'
        altText = 'Completed all Exercises'
        mainText = finishedExercises.length + '/' + assignedExercises.length + ' Exercises'
        clickEvent = this.noEvent
        dataTip = 'You have completed all exercises!'
        var completedClass = 'isCompleted'
        activityTextClass += ' deactivateLink'
      } else {
        completedClass = 'isRequired'
        activityTextClass = 'activityItemText'
        glyphiconClass = 'glyphicon glyphicon-check-gray'
        mainText = finishedExercises.length + '/' + assignedExercises.length + ' Exercises'
      }
    } else if (bookActivity && bookActivity.response_counts) {
      var exercisesCompleted = bookActivity.response_counts[`${item.user_id}`]
      if (exercisesCompleted > 0) {
        if (exercisesCompleted === 1) {
          mainText = `1 Exercise`
        } else {
          mainText = `${exercisesCompleted} Exercises`
        }
      }
    }
    completedClass += ' activityContainer'
    // assigned activity ids with associated book
    var exerciseIDs = 'none'
    var remainingAssignedExercises =
      _.filter(
        _.pluck(
          _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE, draft: true })
        , 'subject_id')
      , activity_id => { return activity_id !== null });
    if (remainingAssignedExercises.length) {
      exerciseIDs = remainingAssignedExercises.join()
    }
    // solo book activities
    var exerciseID = 'none'
    if (item && (item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE || item.subject_type === ACTIVITY_SUBJECT_TYPE)) {
        exerciseID = parseInt(item.subject_id)
        glyphiconClass = item.draft ? 'glyphicon glyphicon-check-gray' : 'glyphicon glyphicon-check-green'
        mainText = item.draft ? '1 Exercise' : 'Exercise Complete'
    }
    mainText = this.truncateMainText(mainText, 25)
    return (
      <a data-complete={completedClass} className={completedClass} data-text-id={this.textID(item)} data-activity-id={exerciseID} data-activity-ids={exerciseIDs} href="#" key={item.id + '_' + item.receivedAt + '_activityIcon'} onClick={clickEvent}
        data-tip={dataTip}>
        <Glyphicon icon='glyphicon glyphicon-check' className={glyphiconClass} />
        <img className='activityIcon' src={require("reading/student-icons-exercise.png")} alt={altText} />
        <span className={activityTextClass} data-text-id={this.textID(item)} data-activity-id={exerciseID} data-activity-ids={exerciseIDs}>{mainText}</span>
      </a>
    )
  }

  renderReadingActivity(item) {
    var glyphiconClass = 'hide-glyphicon'
    var altText = 'Reading Log'
    var mainText = 'Reading Log'
    var clickEvent = this.openLogReading
    var dataTip = 'Reading Log!'

    mainText = this.truncateMainText(mainText, 25)
    return (
      <a className='activityContainer' href="#" data-text-id={this.textID(item)} key={item.id + '_' + item.receivedAt + '_readingIcon'} onClick={clickEvent}
        data-tip={dataTip}>
        <Glyphicon icon='glyphicon glyphicon-check' className={glyphiconClass} />
        <img className='activityIcon' src={require("reading/student-icons-reading.png")} alt={altText} />
        <span className='activityItemText' data-text-id={this.textID(item)}>{mainText}</span>
      </a>
    )
  }

  renderReviewActivity(item) {
    var glyphiconClass = 'hide-glyphicon'
    var altText = 'Complete a Review'
    var mainText = 'Review'
    var clickEvent = this.openReview
    var dataTip = 'Complete the quiz before you start the review!'
    var completedClass = 'notRequired'
    var bookActivity = this.allBookActivity(item)
    var activityTextClass = 'activityItemText'

    var assignedReview = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW });
    if (assignedReview.length) {
      var finishedReview = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW, draft: false });
      if (finishedReview.length) {
        glyphiconClass = 'glyphicon glyphicon-check-green'
        altText = 'Completed Review'
        mainText = '1/1 Review'
        clickEvent = this.noEvent
        dataTip = 'You have completed the review!'
        completedClass = 'isCompleted'
        activityTextClass += ' deactivateLink'
      } else {
        completedClass = 'isRequired'
        activityTextClass = 'activityItemText'
        glyphiconClass = 'glyphicon glyphicon-check-gray'
        mainText = '0/1 Review'
      }
    } else if (bookActivity) {
      if (bookActivity.quiz_counts && bookActivity.quiz_counts[`${item.user_id}`] > 0) {
        mainText = '1/1 Review'
        activityTextClass += ' deactivateLink'
        clickEvent = this.noEvent
      }
    }
    mainText = this.truncateMainText(mainText, 25)
    completedClass += ' activityContainer'
    return (
      <a className={completedClass} data-text-id={this.textID(item)} href="#" key={item.id + '_' + item.receivedAt + '_reviewIcon'} onClick={clickEvent}
        data-tip={dataTip}>
        <Glyphicon icon='glyphicon glyphicon-check' className={glyphiconClass} />
        <img className='activityIcon' src={require("reading/student-icons-review.png")} alt={altText} />
        <span data-text-id={this.textID(item)} className={activityTextClass}>{mainText}</span>
      </a>
    )
  }
  // builds question builder task item
  renderQuestionBuilderActivity(item) {
    if (this.props.showQuestionBuilders) {
      var glyphiconClass = 'hide-glyphicon'
      var altText = 'Complete a Question Builder'
      var mainText = 'Builders'
      var clickEvent = this.openQuestionBuilder
      var dataTip = 'Complete an exercise!'
      var completedClass = 'notRequired'
      var bookActivity = this.allBookActivity(item)
      var activityTextClass = 'activityItemText'

      var assignedQuestionBuilders = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUESTION_BUILDER });

      if (assignedQuestionBuilders.length) {
        var finishedQuestionBuilders = _.where(item.task_items, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUESTION_BUILDER, draft: false });

        if (finishedQuestionBuilders.length === assignedQuestionBuilders.length) {
          glyphiconClass = 'glyphicon glyphicon-check-green'
          altText = 'Completed all Question Builders'
          mainText = finishedQuestionBuilders.length + '/' + assignedQuestionBuilders.length + ' Builders'
          clickEvent = this.noEvent
          dataTip = 'You have completed all question builders!'
          completedClass = 'isCompleted'
          activityTextClass = 'deactivateLink'
        } else {
          completedClass = 'isRequired'
          activityTextClass = 'activityItemText'
          glyphiconClass = 'glyphicon glyphicon-check-gray'
          mainText = finishedQuestionBuilders.length + '/' + assignedQuestionBuilders.length + ' Builders'
        }
      } else if (bookActivity && bookActivity.metacognition_counts) {
        var QuestionBuildersCompleted = bookActivity.metacognition_counts[`${item.user_id}`]
        if (QuestionBuildersCompleted > 0) {
          if (QuestionBuildersCompleted === 1) {
            mainText = `1 Builder`
          } else {
            mainText = `${QuestionBuildersCompleted} Builders`
          }
        }
      }
      completedClass += ' activityContainer'
      mainText = this.truncateMainText(mainText, 25)
      return (
        <a data-complete={completedClass} data-text-id={this.textID(item)} className={completedClass} href="#" key={item.id + '_' + item.receivedAt + '_qbIcon'} onClick={clickEvent}
          data-tip={dataTip}>
          <Glyphicon icon='glyphicon glyphicon-check' className={glyphiconClass} />
          <img className='activityIcon' src={require("reading/student-icons-question-builder.png")} alt={altText} />
          <span className={activityTextClass} data-text-id={this.textID(item)}>{mainText}</span>
        </a>
      )
    } else {
      return null;
    }      
  }

  renderDueDate(item) {
    if (item.subject_type !== 'exercise') {
      var textColor = 'colorBlack'
      var mainText = 'No due date'
      if (item.task_items && item.task_items[0] && item.task_items[0].due_date) {
        if (this.calculatePercentFinished(item.task_items) === 1) {
          var textColor = 'colorGreen'
          mainText = "Completed!"
        } else {
          var today = new Date();
          var dueDate = new Date(item.task_items[0].due_date);
          if (today.getMonth() == 11 && today.getDate() > 25) {
            dueDate.setFullYear(dueDate.getFullYear() + 1);
          }
          var oneDay = 1000 * 60 * 60 * 24;
          var daysRemaining = Math.ceil((dueDate.getTime() - today.getTime()) / (oneDay))
          if (daysRemaining === 0) {
            var textColor = 'colorRed'
            mainText = 'Due today!'
          }
          else if (daysRemaining > 0) {
            if (daysRemaining <= 5) {
              var textColor = 'colorRed'
            }
            mainText = daysRemaining === 1 ? `${daysRemaining} day left!` : `${daysRemaining} days left!`
          }
          else {
            var textColor = 'colorRed'
            mainText = daysRemaining === 1 ? `1 day late!` : `${Math.abs(daysRemaining) } days late!`
          }
        }
        // determins with of bar based on drawer status
        var widthClass = this.state.drawerOpen[`${item.id}`] ? 'truncated' : 'fullWidth'
        var textClass = 'dueDate ' + textColor + ' ' + widthClass;
        
        mainText = this.truncateMainText(mainText, 15)
        return (
          <div className='row dueDateRow'>
            {this.renderBookTitle(item)}
            <div className={'progressBar ' + widthClass}>
              <ProgressBar key={item.id} bgcolor={'#00a0f4'} completed={Math.floor(this.calculatePercentFinished(item.task_items) * 100)} />
            </div>
            <div className={textClass}>{mainText}</div>            
          </div>
        )
      } else {
        return this.renderBookTitle(item)
      }
    }
    else if (item.due_date) {
      var completed = 0
      var textColor = 'colorBlack'
      var today = new Date();
      var dueDate = new Date(item.due_date);
      if (today.getMonth() == 11 && today.getDate() > 25) {
        dueDate.setFullYear(dueDate.getFullYear() + 1);
      }
      var oneDay = 1000 * 60 * 60 * 24;
      var daysRemaining = Math.ceil((dueDate.getTime() - today.getTime()) / (oneDay))
      if (daysRemaining === 0) {
        var textColor = 'colorRed'
        mainText = 'Due today!'
      }
      else if (daysRemaining > 0) {
        if (daysRemaining <= 5) {
          var textColor = 'colorRed'
        }
        mainText = daysRemaining === 1 ? `${daysRemaining} day left!` : `${daysRemaining} days left!`
      }
      else {
        var textColor = 'colorRed'
        mainText = daysRemaining === 1 ? `1 day late!` : `${Math.abs(daysRemaining)} days late!`
      }
      // determins with of bar based on drawer status
      var widthClass = this.state.drawerOpen[`${item.id}`] ? 'truncated' : 'fullWidth'
      var textClass = 'dueDate ' + textColor + ' ' + widthClass;

      if (!item.draft) {
        completed = 100
        mainText = ''
      }
      
      mainText = this.truncateMainText(mainText, 25)
      return (
        <div className='row dueDateRow'>
          {this.renderBookTitle(item)}
          <div className={'progressBar ' + widthClass}>
            <ProgressBar key={item.id} bgcolor={'#00a0f4'} completed={completed} />
          </div>
          <div className={textClass}>{mainText}</div>          
        </div>
      )
    }
  }

  renderBookTitle(item) {
    if (item.text_id) {
      var book = _.first(_.where(this.props.books, { text_id: item.text_id }))
      if (book) {
        return (
          <div className='bookTitle'>{book.title}</div>
        )
      }
    } else if (item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE || item.subject_type === ACTIVITY_SUBJECT_TYPE) {
      var exercise = _.findWhere(this.props.allExercises, { id: parseInt(item.subject_id) })
      if (exercise && exercise.format_summary && exercise.format_summary.title) {
        return (
          <div className='bookTitle'>{exercise.format_summary.title}</div>
        )
      }
    }
  }

  renderBookCover(item) {
    var textID = this.textID(item)
    var book = _.first(_.filter(this.props.books, { text_id: textID }));

    var readNowBtn = ''
    if (book && book.url && item.subject_type === URL_PICK_SUBJECT_TYPE) {
      readNowBtn = (
        <a className="btn btn-link" href={book.url} target="_blank">Read Now</a>
      )
    }

    var thumbnail = ''
    if (item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE || this.isStandAloneBookActivity(item)) {
      if (_.size(item.task_items)) {
        var activity = _.first(_.filter(this.props.allExercises, activity => activity.id === parseInt(_.first(item.task_items).subject_id)))
      } else {
        var activity = _.first(_.filter(this.props.allExercises, activity => activity.id === parseInt(item.subject_id)))
      }
    } else if (item.subject_type === ACTIVITY_SUBJECT_TYPE) {
      var activity = _.findWhere(this.props.allExercises, { id: parseInt(item.subject_id) })
    }
    if (!_.isEmpty(activity)) {
      thumbnail = activity.thumbnail.url || this.getPlaceholderImage()
    }

    if (!item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE && !this.isStandAloneBookActivity(item)) {
      return (
        <div className='col-sm-2 activityColumn bookCoverContainer'>
          <BookCover book={book} coverWidth={105}
            showTitle={false} showAuthor={false}
          />
        </div>
      )
    } else {
      if (!book && thumbnail !== '') {
        return (
          <div className='col-sm-2 activityColumn bookCoverContainer'>
            <span className="bookCover activityCover" >
              <img src={thumbnail} className="activityCoverImage" />
            </span>
          </div>
        )
      } else if (book) {
        return (
          <div className='col-sm-2 activityColumn bookCoverContainer'>
            <BookCover book={book} coverWidth={105}
              showTitle={false} showAuthor={false}
            />
            {readNowBtn}
          </div>
        )
      }
    }
  }
  drawerToggleClickHandler(item_id) {
    var drawerStateCopy = { ...this.state.drawerOpen }
    drawerStateCopy[`${item_id}`] = !drawerStateCopy[`${item_id}`]
    this.setState({ drawerOpen: drawerStateCopy })
  }
  // renders row content
  renderMainContent(item) {
    if (item.subject_type === ACTIVITY_SUBJECT_TYPE || item.subject_type === StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE ) {
      return (
        <div className='row row-padding-bottom'>
          <div className='col-sm-10 padding-left'>
            {this.renderExerciseActivity(item)}
          </div>
        </div>
      )

    } else {
      var activityElements = [
        this.renderQuestionActivity(item),
        this.renderExerciseActivity(item),
        this.renderQuizActivity(item),
        this.renderReviewActivity(item),
        this.renderQuestionBuilderActivity(item),
        this.renderReadingActivity(item)
      ]
      if (!this.hasQualifiedPlan()) {
        activityElements = [
          this.renderQuestionActivity(item),
          this.renderQuizActivity(item),
          this.renderReviewActivity(item),
          this.renderQuestionBuilderActivity(item)
        ]
      }

      activityElements = _.compact(activityElements)

      // sort activities by required then completed
      activityElements = _.sortBy(activityElements, (element) => {
        return !element.props.className.includes('isRequired')
      })

      activityElements = _.sortBy(activityElements, (element) => {
        return !element.props.className.includes('isCompleted')
      })

      var requiredElements = _.filter(activityElements, (element) => {
        return element.props.className.includes('isRequired') || element.props.className.includes('isCompleted')
      })

      var additionalElements = _.filter(activityElements, (element) => {
        return !element.props.className.includes('isRequired') && !element.props.className.includes('isCompleted')
      })

      // handle items with no assignments
      if (_.isEmpty(requiredElements)) {
        requiredElements = activityElements
        additionalElements = []
      }
      var borderClass = ''
      var additionalHeightClassRight = ''
      var additionalHeightClassLeft = ''
      var triggerText = 'View all activities'

      if (_.isEmpty(additionalElements)) {
        var rightColumn = requiredElements.slice(0, 3).map(i => { return i })
        var leftColumn = requiredElements.slice(3, (requiredElements.length)).map(i => { return i })
        return (
          <div>
            <div className={'col-sm-5 activityColumn assignedActivityContainer ' + borderClass}>
              {rightColumn}
            </div>
            <div className={'col-sm-5 activityColumn additionalActivityContainer' + borderClass}>
              {leftColumn}
            </div>
          </div>
        )

      } else {
        // controlls display and height of optional activities column
        if (requiredElements.length >= 4) {
          additionalHeightClassRight = 'expandedColumn300'
          additionalHeightClassLeft = 'expandedColumn300'
        }

        if (this.state.drawerOpen[`${item.id}`]) {
          borderClass = 'borderLeft'
          triggerText = 'Hide'
          if (additionalElements.length === 3) {
            additionalHeightClassRight = 'expandedColumn220'
          } else if (additionalElements.length >= 4) {
            additionalHeightClassRight = 'expandedColumn300'
          }
        }
        return (
          <div>
            <div className={'col-sm-5 assignedActivityContainer activityColumn ' + borderClass + ' ' + additionalHeightClassLeft}>
              {requiredElements}
            </div>
            <div className={'col-sm-5 additionalActivityContainer activityColumn ' + borderClass + ' ' + additionalHeightClassRight}>
              < SlidingDrawer show={this.state.drawerOpen[`${item.id}`]} content={additionalElements} />
              <a className='drawerTrigger' onClick={this.drawerToggleClickHandler.bind(this, item.id)}>{triggerText}</a>
            </div>
          </div>
        )
      }
    }
  }

  render() {
    var allActivityElements = [];

    var revisableQuizTasks = [];
    var revisableAnswerTasks = [];
    var revisableReviewTasks = [];

    _.each(this.props.revisables, (item) => {

      if (item.type == "quiz") {
        var altText = "Revise your quiz";
        var imgPath = require("action-icons/quizzes-passed.png")

      } else if (item.type == "answer") {
        var altText = "Revise your answer";
        var imgPath = require("action-icons/questions.png")

      } else if (item.type == "review") {
        var altText = "Revise your review";
        var imgPath = require("action-icons/reviews.png")

      } else {
        console.error("Unkonwn revisable-task item type: ", item.type);
      }

      var tile = (
        <div className="revisionTask" key={item.type + '_' + item.text_id + '_revisable'} data-text-id={this.textID(item)} data-item-type={item.type} onClick={this.onRevisionClick}>
          <img src={imgPath} alt={altText} />
          <div className="taskTitle">
            <BookDisplay textID={item.text_id} />
          </div>
          <span className="category">
            Revision
          </span>
        </div>
      );

      if (item.type === "quiz") {
        revisableQuizTasks.push(tile);
      } else if (item.type === "answer") {
        revisableAnswerTasks.push(tile);
      } else if (item.type === "review") {
        revisableReviewTasks.push(tile);
      } else {
        console.error("Unkonwn revisable-task item type: ", tile.type);
      }
    })
    // use to determine if activity is past due
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    _.each(this.state.allActivities, (item, index) => {
      var className = index === this.state.allActivities.length - 1 ? 'activityRowContainer' : 'activityRowContainer borderBottom'
      allActivityElements.push(
        <div className={className} key={item.id + '_' + index}>
          {this.renderDueDate(item)}
          <div className='row pickContainer'>
            {this.renderBookCover(item)}
            {this.renderMainContent(item)}
          </div>
        </div>
      );
    });

    if (this.props.gridView) {
      var containerClassName = 'studentTaskGridContainer'
    }
    else {
      var containerClassName = 'studentActivitiesContainer'
    }

    return (
      <div className={containerClassName}>
        <div className="studentActivities">
          {revisableQuizTasks}
          {revisableAnswerTasks}
          {revisableReviewTasks}
          {allActivityElements}
        </div>
      </div>
    );
  }
};

var ACTIVITY_SUBJECT_TYPE = 'Activity'
var URL_PICK_SUBJECT_TYPE = 'URLPick'
var TITLE_PICK_SUBJECT_TYPE = 'TitlePick'

StudentActivities.WrappedComponent.propTypes = StrictPropTypes({
  onPickSelect: PropTypes.func,
  onActivitySelect: PropTypes.func,
  openBookActivity: PropTypes.func,
  fetchActivity: PropTypes.func,
  activity: PropTypes.func,
  // Data from @connect
  product: PropTypes.string,
  revisables: PropTypes.array,
  allActivities: PropTypes.array,
  allTasks: PropTypes.array,
  soloBookActivities: PropTypes.array,
  assignedActivities: PropTypes.array,
  assignedTitles: PropTypes.array,
  assignedURLs: PropTypes.array,
  teacherPicks: PropTypes.array,
  books: PropTypes.array,
  standAloneExercises: PropTypes.array,
  allExercises: PropTypes.array,
  showQuestionBuilders: PropTypes.bool,

  // Handlers from @connect
  populateData: PropTypes.func,

  gridView: PropTypes.bool
});

module.exports = StudentActivities;


// WEBPACK FOOTER //
// ./modules/components/users/students/StudentActivities.js